module.exports = __webpack_public_path__ + "img/loopcad.3c19a95c.png";